<!-- Start Preloader Area -->
<div class="preloader">
    <div class="spinner">
        <img src="assets/image/RE-logo.png">
    </div>
</div>
<!-- End Preloader Area -->
